import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

import { computed, PropType } from 'vue'
import WidgetDay from '@/components/booking-widget/WidgetDay.vue'
import { MinimumTimeslot } from '@/models/public/service.model'
import {
  ITicketItemDateAvailability,
  ITicketItemDateAvailabilityTimeslot,
} from '@/models/service/serviceTicket.model'


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetTicketDay',
  props: {
  day: {
    type: Object as PropType<Date>,
    default: new Date(),
  },
  slots: {
    type: Array as PropType<MinimumTimeslot[]>,
    default: () => [],
  },
  selectedSlots: {
    type: Array as PropType<MinimumTimeslot[]>,
    default: () => [],
  },
  timeSlots: {
    type: Array as PropType<number[]>,
    required: true,
  },
  ticketAvailabilities: {
    type: Array as PropType<ITicketItemDateAvailability[]>,
    default: () => [],
  },
},
  emits: ['onClick'],
  setup(__props, { emit: emits }) {

const props = __props





const timeslots = computed<ITicketItemDateAvailabilityTimeslot[]>(() =>
  props.ticketAvailabilities.flatMap(
    (availability: ITicketItemDateAvailability) => availability.timeslots,
  ),
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "widget-calendar-ticket__timeslot",
    style: _normalizeStyle(`grid-template-columns: repeat(${_unref(timeslots).length}, minmax(0, 1fr));`)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeslots), (timeslot, index) => {
      return (_openBlock(), _createBlock(WidgetDay, {
        key: timeslot.id,
        "with-labels": index === 0,
        day: __props.day,
        slots: __props.slots,
        "time-slots": __props.timeSlots,
        "selected-slots": __props.selectedSlots,
        "slot-id": timeslot.id,
        onOnClick: _cache[0] || (_cache[0] = (value) => emits('onClick', value))
      }, null, 8, ["with-labels", "day", "slots", "time-slots", "selected-slots", "slot-id"]))
    }), 128))
  ], 4))
}
}

})